import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';
import Header from './Header.js';

class AttorneyForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            has_attorney: null,
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const attorney_options = [{id:0 , name:'Si'}, {id:1 , name:'No'}]

        return (

             <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FormattedHTMLMessage id="app.step_fields" description="Fields Generic"/>
                    </Header>
                     <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                         <form onSubmit={handleSubmit(this.props.HasAttorney)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="has_attorney" defaultValue="¿Es Apoderado?" label="¿Es Apoderado?" attributeName='has_attorney' attributeOptions={attorney_options}/>
                                    </div>
                                </div>
                            </div>
                            <FormattedHTMLMessage id="app.step_has_attorney" description="Attorney Info"/>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <SaveStepButton/>
                    </div>
                </div>
            </Section>
        );
    }
}

AttorneyForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

AttorneyForm = TopScrolleable(AttorneyForm);
let validate = generateValidator([{name: 'has_attorney', required: true}]);

AttorneyForm = reduxForm({
    form: 'AttorneyForm', // a unique name for this form
    validate
})(AttorneyForm);

AttorneyForm = withAuthControl(AttorneyForm);

export default AttorneyForm;



/** WEBPACK FOOTER **
 ** ./src/components/AttorneyForm.js
 **/